import VueCookies from 'vue-cookies'

const ACCESS_TOKEN_KEY = 'access_token'
const ACCESS_TOKEN_TYPE = 'access_token_type'
const ACCESS_TOKEN_TYPE_EXTERNAL = 'ext'
const ACCESS_TOKEN_TYPE_INTERNAL = 'int'
const STATE_KEY = 'state'
const TOKEN_VALIDATE_URL = 'validateURL'
const CHAT_TOKEN_KEY = 'chatToken'

export { clearState, getState, setState, clearAccessToken, getAccessToken, getTokenType, setAccessToken,
  ACCESS_TOKEN_TYPE_EXTERNAL, ACCESS_TOKEN_TYPE_INTERNAL, setValidateURL, getValidateURL, setChatToken, 
  getChatToken, getBaseDomain, getStateCookie }

function getBaseDomain () {
  var h = window.location.hostname
  let bd = h.split('.')
  let n = bd.length
  console.log('Domain length: ' + n)
  if (n > 1) {
    return bd[n-2] + '.' + bd[n-1]
  } else {
    return bd[0]
  }
}

function setChatToken (accessToken) {
  let bd = getBaseDomain()
  console.log('Setting chat cookie for: ' + bd + ', token: ' + accessToken)
  VueCookies.set(CHAT_TOKEN_KEY, accessToken, null, null, bd)
}

function getChatToken () {
  return VueCookies.get(CHAT_TOKEN_KEY)
}

function clearState () {
  console.log('clearState start')
  localStorage.removeItem(STATE_KEY)
}

function getState () {
  var s = localStorage.getItem(STATE_KEY)
  console.log('getState from localStorage: ' + s)
  return s
}

function getStateCookie () {
  var s = VueCookies.get(STATE_KEY)
  console.log('getStateCookie from cookie: ' + s)
  return s
}

function setState (state) {
  console.log('setState from param: ' + state)
  clearState()
  localStorage.setItem(STATE_KEY, state)
  console.log('localStore after set state:')
  console.log(localStorage)
}

function clearAccessToken () {
  console.log('clearAccessToken start')
  sessionStorage.removeItem(ACCESS_TOKEN_KEY)
}

function getAccessToken () {
  var s = sessionStorage.getItem(ACCESS_TOKEN_KEY)
  console.log('getAccessToken from sessionStorage: ' + s)
  return s
}

function getTokenType () {
  var s = sessionStorage.getItem(ACCESS_TOKEN_TYPE)
  console.log('getTokenType from sessionStorage: ' + s)
  return s
}

function setAccessToken (accessToken, tokenType) {
  console.log('setAccessToken: ' + accessToken + ', tokenType: ' + tokenType)
  clearAccessToken()
  sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
  sessionStorage.setItem(ACCESS_TOKEN_TYPE, tokenType)
  console.log('sessionStorage after setAccessToken:')
  console.log(sessionStorage)
  setChatToken(accessToken)
}

function setValidateURL (validateURL) {
  sessionStorage.setItem(TOKEN_VALIDATE_URL, validateURL)
}

function getValidateURL () {
  return sessionStorage.getItem(TOKEN_VALIDATE_URL)
}
